import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class IntegrationID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
